import { BaseModel, attr } from "../../lib/itn-ui-kit/data";

export default class RouteModel extends BaseModel {
  static urlPath = "core/routes";

  @attr("string") route;
  @attr("string") display;
  @attr("string") description;
  @attr("number") dashboardLaneCount;
}
